export enum Language {
  En = 'en',
  Fr = 'fr'
}

export enum RelationEntityType {
  Question = 0
}

export interface IAutomationRelation {
  automationId?: string;
  relationEntityId: string;
  typeId: RelationEntityType;
}

export type ProcessTranslatableFields = {
  label: string;
};

export type ProcessTranslation = ProcessTranslatableFields & {
  language: Language;
};

export interface IProcess extends ProcessTranslatableFields {
  id: string;
  formPath: string;
  organizationId: string;
  organizationName: string;
  externalWorkflowId: number | string;
  teamId: number;
  type: AutomationType;
  createdBy: string;
  updatedBy: string;
  createdDateTimeUtc: string;
  updatedDateTimeUtc: string;
  resourceId: string;
  isActive: boolean;
  automationRelations?: IAutomationRelation[];
}

export interface IProcessTranslated extends IProcess {
  translations: ProcessTranslation[];
  language?: Language;
}

export interface IProcessForm {
  translations: Record<Language, ProcessTranslatableFields> | {};
  organizationId: string;
  externalWorkflowId: number | string;
  formPath: string;
  resourceId: string;
  type: string;
  isActive: boolean;
  questionIds: string[];
}

export enum ProcessType {
  AddContractor = 0,
  ContractorAssessment = 1,
  ScoreSetVariance = 2,
  IncidentReport = 3,
  Inspections = 4,
  InsuranceVariance = 5
}

export const automationType = {
  '0': 'AddContractor',
  '1': 'ContractorAssessment',
  '2': 'ScoreSetVariance',
  '3': 'IncidentReport',
  '4': 'Inspections',
  '5': 'InsuranceVariance'
} as const;

export type AutomationType = keyof typeof automationType;
